import React from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { OrderItem } from '../../../models/OrderItem';
import { ProductGrouping } from '../../../models/ProductGrouping';
import { If } from '../../../common-components/If/If';
import { FormTable, FormTableDataCell, FormTableHeaderCell, FormTableRow } from './styles';

interface IFormProductGroupByTypeProps {
  headerTitle: string;
  messageForEmptyList?: string;
  orderItems?: OrderItem[];
  productGroups?: ProductGrouping[];
  changeSelectedItem?: (orderItemId: number) => void;
}

const FormProductGroupByType: React.FC<IFormProductGroupByTypeProps> = ({
  headerTitle,
  messageForEmptyList,
  orderItems,
  productGroups,
  changeSelectedItem
}) => {

  const listLength = orderItems?.length || 0;

  return (
    <Card>
      <Card.Header>
        {headerTitle}
      </Card.Header>
      <Card.Body>
        <If condition={listLength > 0}>
          <FormTable>
            <thead>
              <FormTableRow>
                <FormTableHeaderCell width='20px'></FormTableHeaderCell>
                <FormTableHeaderCell width='120px'>SKU</FormTableHeaderCell>
                <FormTableHeaderCell width='50%'>Nome</FormTableHeaderCell>
                <FormTableHeaderCell width='100px'>Código</FormTableHeaderCell>
                <FormTableHeaderCell width='70px'>Qtde</FormTableHeaderCell>
                <FormTableHeaderCell width='70px'>Grupos</FormTableHeaderCell>
              </FormTableRow>
            </thead>
            <tbody>
              {orderItems?.map(orderItem => {
                return (
                  <FormTableRow key={`order-item-${orderItem.id}`}>
                    <FormTableDataCell><Form.Check type='checkbox' onChange={(e: any) => changeSelectedItem && changeSelectedItem(orderItem.id)}/></FormTableDataCell>
                    <FormTableDataCell>{orderItem.sku}</FormTableDataCell>
                    <FormTableDataCell>{orderItem.name}</FormTableDataCell>
                    <FormTableDataCell>{orderItem.id}</FormTableDataCell>
                    <FormTableDataCell>{orderItem.quantity}</FormTableDataCell>
                    <FormTableDataCell>{productGroups?.filter(pg => pg.productGroupingItems?.some(pgi => pgi.orderItemId == orderItem.id))?.length || 0}</FormTableDataCell>
                  </FormTableRow>
                )
              })}
            </tbody>
          </FormTable>
        </If>
        <If condition={listLength === 0}>
          {messageForEmptyList || 'O pedido não possui registros deste tipo.'}.
        </If>
      </Card.Body>
    </Card>
  );

}

export { FormProductGroupByType };